import React from 'react';
import { Row } from 'reactstrap';
import './styles.scss';
export * from './horizontalLine/horizontalLine';
interface TachoToolbarProps {
    className?: string;
}
export function TachoToolbar(props: React.PropsWithChildren<TachoToolbarProps>): JSX.Element {
    return (
        <Row className="g-0">
            <div className={`tachoToolbarContainer ${props.className ?? ''}`}>{props.children}</div>
        </Row>
    );
}
